import React from "react";

// Solo http(s)://... — no "www.foo.com" sin esquema, para no convertir en
// enlace un fragmento de texto que solo *parece* un dominio.
const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+)/g;
const IS_URL_REGEX = /^https?:\/\//;

/**
 * LinkifiedText — renderiza texto plano (p.ej. la descripción de un tema)
 * detectando URLs y convirtiéndolas en enlaces clicables, sin necesitar que
 * el autor escriba markdown/HTML. Preserva saltos de línea del textarea de
 * origen (white-space: pre-wrap) y corta URLs largas sin desbordar el layout.
 */
function LinkifiedText({ text, className, as: Component = "span" }) {
  if (!text) return null;
  const parts = String(text).split(URL_SPLIT_REGEX);
  return (
    <Component className={className} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
      {parts.map((part, i) =>
        IS_URL_REGEX.test(part) ? (
          <a key={i} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </Component>
  );
}

export { LinkifiedText };
